// extracted by mini-css-extract-plugin
export default {"headers":"LaunchpadListPage_headers__1uFr+"};